import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuPortal,
    DropdownMenuSeparator,
    DropdownMenuShortcut,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { User } from "types";
import { useState } from "react";

export const SetPresence = ({ children, socket }: { children: React.ReactNode, user: User, socket: WebSocket }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onClick = async (status: Number) => {
        const response = await fetch(`__SITE_BASE__/api/v1/me/presence`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                status: status
            })
        });
        const data = await response.json();
        if(data.success) {
            setIsOpen(false);
            socket.send(JSON.stringify({ t: "PRESENCE_UPDATE", d: { presence: status }}));
        }
    };

    return (
        <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
            <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
            <DropdownMenuPortal>
                <DropdownMenuContent className="w-56 bg-brand-darkest rounded border-0 ml-28">
                    <DropdownMenuSeparator />
                    <DropdownMenuGroup className="mb-2">
                        
                        <DropdownMenuItem className="hover:bg-gray-600" onClick={() => onClick(1)}>
                            <DropdownMenuLabel>Online</DropdownMenuLabel>
                            <DropdownMenuShortcut>
                                <div className="w-3 h-3 rounded-full bg-green-500" />
                            </DropdownMenuShortcut>                            
                        </DropdownMenuItem>

                        <DropdownMenuItem className="hover:bg-gray-600" onClick={() => onClick(2)}>
                            <DropdownMenuLabel>Idle</DropdownMenuLabel>
                            <DropdownMenuShortcut>
                                <div className="w-3 h-3 rounded-full bg-orange-500" />
                            </DropdownMenuShortcut>
                        </DropdownMenuItem>

                        <DropdownMenuItem className="hover:bg-gray-600" onClick={() => onClick(3)}>
                            <DropdownMenuLabel>
                                Do Not Disturb
                            </DropdownMenuLabel>
                            <DropdownMenuShortcut>
                                <div className="w-3 h-3 rounded-full bg-red-500" />
                            </DropdownMenuShortcut>
                        </DropdownMenuItem>

                        <DropdownMenuItem className="hover:bg-gray-600" onClick={() => onClick(0)}>
                            <DropdownMenuLabel>Offline</DropdownMenuLabel>
                            <DropdownMenuShortcut>
                                <div className="w-3 h-3 rounded-full bg-gray-500" />
                            </DropdownMenuShortcut>
                        </DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenuPortal>
        </DropdownMenu>
    );
};
